import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import TariffsContent from '../../components/Pages/Tariffs';

const { displayName } = config;

export default function Tariffs(): React.ReactNode | null {
  document.title = `${displayName}: Tariffs`;

  return (
    <Layout
      title="List of Tariffs"
    >
      <TariffsContent />
    </Layout>
  );
}
